import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../app.settings';
 

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  pdfUrl = `${AppSettings.API_ENDPOINT}/${'get-pdf-list'}`;
  // keywordPercentageUrl = `${AppSettings.API_ENDPOINT}/${'get-questions-pdf-file-name'}`;
  transcriptUrl = `${AppSettings.API_ENDPOINT}/${'get-pdf-text-by-file-name'}`;
  questionTranscriptUrl = `${AppSettings.API_ENDPOINT}/${'get-questions-pdf-file-name'}`;
  infoDetailUrl = `${AppSettings.API_ENDPOINT}/${'get-topic/1'}`;
  infoUpdateUrl = `${AppSettings.API_ENDPOINT}/${'update-pdf-file'}`;
  deletePdfUrl = `${AppSettings.API_ENDPOINT}/${'delete'}`;
  translateUrl_1 = `${AppSettings.API_ENDPOINT}/${'get-transcription-text'}`;
  translateUrl_2 = `${AppSettings.API_ENDPOINT}/${'translate'}`;

  constructor(private http: HttpClient) { }

  getPdfData(data:any){
    return this.http.post(this.pdfUrl, data);
  }

  // getKeywordPercentageData(id:string){
  //   return this.http.get(`${this.keywordPercentageUrl}/${id}`);
  // }

  getTranscriptData(id:string){
    return this.http.get(`${this.transcriptUrl}/${id}`);
  }
  
  getKeywordTranscriptData(id:string){
    return this.http.get(`${this.questionTranscriptUrl}/${id}`);
  }

  getInfo(){
    return this.http.get(this.infoDetailUrl);
  }

  updateInfo(data:any){
    return this.http.post(this.infoUpdateUrl, data);
  }

  deletePdfTable(data:any){
    return this.http.post(this.deletePdfUrl, data);
  }

  getTranscriptionOriginalText(id:string){
    return this.http.get(`${this.translateUrl_1}/${id}/pdf`);
  }

  getTranslatedLanguageData(data:any){
    return this.http.post(this.translateUrl_2, data);
  }

}
